import { render } from "./custom_field.vue?vue&type=template&id=384c7798"
import script from "./custom_field.vue?vue&type=script&lang=js"
export * from "./custom_field.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__